// const hostname = window && window.location && window.location.hostname;
const hostname = getHostName(window.location.href) || "";
let domain_name = window.location.protocol + "//" + window.location.hostname;

if (window.location.hostname === "localhost" || hostname === "192.168.0.141") {
  //DATA.SUPPORT_EMAIL = 'hriziya@gmail.com';
  domain_name = "http://localhost/RSA/aog-frontend-transit";
}
// export const API_ROOT = `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/`;
// console.log(window.location);
let backendHost = "";
var hash = ""; // e.g.  "#/ABC/coupons/deli"
let hash_c = ""; // customer = ABC
let hash_p = "/"; // page  = coupons
let only_coupons = false; // used to load site having only coupons access like petclub
let beta_site = false; // used to host mutliple site on same domain.
let beta_path = "/"; // store the path from the url.
var qry = ""; // send extra params for Coupons only or Beta site setup

// https://grocery2xl.com/#/petclub/coupons
if (window.location.hash !== "" && window.location.hash !== "#") {
  hash = window.location.hash;
  if (hash.length >= 5) {
    var hashlist = hash.split("/");
    if (hashlist.length > 1) {
      hash_c = hashlist[1];

      if (hashlist.length > 2) {
        hash_p = hashlist[2];
      }
      //console.log(hash_c, hash_p);
      backendHost = hash_c;

      only_coupons = true;
    }
  }
} else if (
  window.location.hostname === "localhost" ||
  hostname === "groceryxl.net"
) {
  beta_site = true;
  beta_path = window.location.pathname;
  beta_path = beta_path.substr(1); // remove leading slash
  if (beta_path.indexOf("/") > -1) {
    beta_path = beta_path.substring(0, beta_path.indexOf("/"));
  }
}

// to fix routing which was not working on localhost
if (window.location.hostname === "localhost") {
  beta_site = false;
  beta_path = "/";
}

qry = only_coupons ? "&site=" + hash_c : qry;
qry = beta_site ? "&beta_site=" + beta_path : qry;
const localFileName =
  window.location.hostname === "localhost"
    ? window.location.pathname.split("/")[1]
    : window.location.hostname.split(".")[1];
//console.log('qry',qry);
var response = null;
var xhr = new XMLHttpRequest();
var xhr1 = new XMLHttpRequest();

xhr1.open(
  "GET",
  `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/clientinfo?FileName=domainFileMap`,
  false
);
xhr1.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
xhr1.send("FileName=" + `domainFileMap`);

let configRespData = JSON.parse(xhr1.response);

const localhostName = window.location.hostname === "localhost";

let domainName = localhostName
  ? "localhost"
  : window.location.hostname.slice(4);

let href = window.location.href
if (href.endsWith("/")) {
  href = href.slice(0, -1)
}
let grocery2xlFileName = ""
// let href = "https://grocery2xl.com/#/petesfresh"
const domains = [
  "https://grocery2xl.com/#/", 
  "https://groceryxl.net/",
  "http://grocery2xl.com/#/", 
  "http://groceryxl.net/",
  "https://www.grocery2xl.com/#/", 
  "https://www.groceryxl.net/",
  "http://www.grocery2xl.com/#/", 
  "http://www.groceryxl.net/",
  "http://localhost:3004/#/",
]
for (const domain of domains) {
  if (href.startsWith(domain)) {
    grocery2xlFileName = href.replace(domain, "")
    grocery2xlFileName = grocery2xlFileName.split("/")[0]
    break
  }
}

let fileNameString = beta_site ? beta_path : configRespData.data[domainName];
if (window.location.hostname === "aog-lite.web.app") {
  // fileNameString = "prengerfoods";
  fileNameString = "handyfoodsiga";
}
if (grocery2xlFileName) {
  fileNameString = grocery2xlFileName
}

if (localhostName) {
  // const fileNameString = "claibornesthriftway";
  // const fileNameString = "prengerfoods";
  // fileNameString = "eldens";
  // fileNameString = "buchefoods";
  // fileNameString = "brooks";
  // fileNameString = "almichsmarket";
  // fileNameString = "tersteegs";
  // fileNameString = "eldens";
  fileNameString = "handyfoodsiga";
}
xhr.open(
  "GET",
  `https://ra14ql4rs6.execute-api.us-east-1.amazonaws.com/prod/clientinfo?FileName=${fileNameString}`,
  false
);
xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
xhr.send("FileName=" + `${fileNameString}`);

response = JSON.parse(xhr.response);

if (response.error != 0) {
  // backendHost = 'whites';
  // alert("Invalid Host: "+ hostname);
  // throw new Error("Oops! something went wrong - Please try again later...");
  const style = '"font-family: Roboto; padding: 17% 0 0 17%"';
  document.getElementById("error_info").innerHTML =
    "<h1 style=" + style + ">Oops! something went wrong - Please try again later...</h1>";
  document.getElementById("root").style.display = "none";
}

if (backendHost === "") {
  backendHost = response.basename || "";
}

if (
  backendHost === "" &&
  (hostname === "localhost" || hostname === "grocery2xl.com")
) {
  // only_coupons = true;
} else if (backendHost === "" && window.location.hostname === "localhost") {
  // alert("Invalid Host: "+ hostname);
  // throw new Error("Oops! something went wrong - Please try again later...");
  const style = '"font-family: Robotoś; padding: 17% 0 0 17%"';
  document.getElementById("error_info").innerHTML =
    "<h1 style=" + style + ">Oops! something went wrong - Please try again later...</h1>";
  document.getElementById("root").style.display = "none";
}

export const API_HOST = hostname;
export var DATA = response.data || [];
var COMMON = response.common || [];

//export var DATA = backendHost !== '' ? require(`./_config_${backendHost}`).default : {};
// DATA.CUSTOM_SCRIPT_URL = "https://js.adsrvr.org/up_loader.1.1.0.js";
// DATA.HAS_CUSTOM_SCRIPT_TAG = true;

DATA.API_HOST = hostname;
DATA.BACKEND_HOST = backendHost;
DATA.MENU = DATA.MENU || [];
DATA.TESTIMONIAL = DATA.TESTIMONIAL || [];
DATA.BETA_SITE = DATA.BETA_SITE === true || beta_site === true;
DATA.ONLY_COUPONS = DATA.ONLY_COUPONS === true || only_coupons === true;
DATA.BASEPATH = only_coupons
  ? "/#/" + hash_c + "/"
  : beta_site
  ? "/" + beta_path + "/"
  : "/";
DATA.DOMAIN_URL = DATA.DOMAIN_URL ? DATA.DOMAIN_URL : "https://rsaamerica.com";
DATA.THEME = DATA.THEME || 1;
DATA.BASIC_THEME = DATA.BASIC_THEME || false;
DATA.HAS_CUSTOM_CSS = DATA.HAS_CUSTOM_CSS || false;
DATA.IS_PHONE_NUMBER_REQUIRED = DATA.IS_PHONE_NUMBER_REQUIRED || false;
DATA.SUPPORT_EMAIL_RSA = "support@rsaamerica.com";
DATA.SUPPORT_EMAIL =
  DATA.SUPPORT_EMAIL === "" ? DATA.SUPPORT_EMAIL_RSA : DATA.SUPPORT_EMAIL;
// Revised on 2019-10-16 to send all 3 emails default to Clients address.
// DATA.EMPLOYMENT_EMAIL = backendHost === 'sunshine' ? DATA.SUPPORT_EMAIL : DATA.SUPPORT_EMAIL_RSA;
DATA.RSA_CLIENT_APP_NAME = DATA.RSA_CLIENT_APP_NAME || "RSA America";

DATA.ALLOW_EMPLOYMENT_SCREEN = DATA.ALLOW_EMPLOYMENT_SCREEN || false;
DATA.ALLOW_LINK_CARD_REGISTRATION = DATA.ALLOW_LINK_CARD_REGISTRATION || false;
DATA.LINK_CARD_MOBILE_IMAGE = DATA.LINK_CARD_MOBILE_IMAGE || "";
DATA.ALLOW_EMPLOYMENT_PAGE_AGE_FILED_OPTION =
  DATA.ALLOW_EMPLOYMENT_PAGE_AGE_FILED_OPTION || false;
DATA.LOGO_HEADER = DATA.LOGO_HEADER || "/assets/images/icons/RSALogo.png";
DATA.LOGO_FOOTER = DATA.LOGO_FOOTER || "/assets/images/icons/RSALogo.png";
DATA.LOGO_FAVICON = DATA.LOGO_FAVICON || "/assets/favicon/rsa.ico";

DATA.HEADER_BG_COLOR = DATA.HEADER_BG_COLOR || "#318501";

DATA.ABOUT_FOOTER = ""; // This is not in use. so just discard it, data should be loaded from API always

// coupons page top image.
DATA.COUPON_PAGE_TOP_IMAGE =
  DATA.COUPON_PAGE_TOP_IMAGE || "/assets/images/inner-banner4.jpg";
DATA.FACEBOOK_URL = DATA.FACEBOOK_URL || "";
DATA.ANALYTIC_FB_PIXEL_ID = DATA.ANALYTIC_FB_PIXEL_ID || "";
DATA.FB_DOMAIN_VERIFICATION_CODE = DATA.FB_DOMAIN_VERIFICATION_CODE || "";
DATA.ANALYTIC_GOOGLE_TAG_MANAGER_ID = DATA.ANALYTIC_GOOGLE_TAG_MANAGER_ID || "";
DATA.ALLOW_CHANGE_CUSTOMER_EMAIL_ID = DATA.ALLOW_CHANGE_CUSTOMER_EMAIL_ID || "";
DATA.NEIGHBORHOOD_TEXT =
  DATA.NEIGHBORHOOD_TEXT || "We are in your neighborhood";

// If the Tutorial Submenu page available or not..
DATA.HAS_SHOP_TUTORIAL_PAGE = DATA.HAS_SHOP_TUTORIAL_PAGE || false;

// Wording for Add to Cart / Add to List
DATA.ADD_TO_CART_TEXT =
  backendHost === "countyfairfoodstores" ? "Add to List" : "Add to Cart";
DATA.REMOVE_FROM_CART_TEXT =
  backendHost === "countyfairfoodstores"
    ? "Remove from List"
    : "Remove from Cart";

// Weekly Ad view is Gallery or full screen
DATA.WEEKLY_AD_FULL_SCREEN = DATA.WEEKLY_AD_FULL_SCREEN || false;

// remove the static text from config file.
DATA.SUPPORT_EMAIL = null;
DATA.SUPPORT_EMAIL_STORE = null;
DATA.SUPPORT_PHONE = null;
DATA.SUPPORT_TIME = null;
DATA.ABOUT_FOOTER = null;
DATA.COUPON_PAGE_DISCLAIMER_TEXT =
  DATA.COUPON_PAGE_DISCLAIMER_TEXT ||
  "Coupon availability varies by store location due to products offered at each store – log in to account to see accurate coupon selection";

const clientListToLoadStoreFromDifferentUrl = [
  "lawrence",
  "cashsaver",
  "diamondfood",
  "cashsaverstore",
  "metrodiscount",
  "lawrencebrostx",
];
DATA.LOAD_STORE_FROM_DIFFERENT_URL =
  clientListToLoadStoreFromDifferentUrl.includes(backendHost);

// merge common data object with site specific settings
DATA = { ...COMMON, ...DATA };
// console.log(DATA);

document.title = DATA.RSA_CLIENT_APP_NAME;

function getHostName(url) {
  var match = url.match(/:\/\/(www[0-9]?\.)?(.[^/:]+)/i);
  if (
    match !== null &&
    match.length > 2 &&
    typeof match[2] === "string" &&
    match[2].length > 0
  ) {
    return match[2];
  } else {
    return null;
  }
}

/*
function getDomain(url) {
    var hostName = getHostName(url);
    var domain = hostName;

    if (hostName !== null) {
        var parts = hostName.split('.').reverse();

        if (parts !== null && parts.length > 1) {
            domain = parts[1] + '.' + parts[0];

            if (hostName.toLowerCase().indexOf('.co.uk') !== -1 && parts.length > 2) {
              domain = parts[2] + '.' + domain;
            }
        }
    }
    return domain;
}
*/
